import { applyMiddleware, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";

import rootReducer from "./reducers";
import rootSaga from "./sagas";
// import refreshAuthMiddleware from "./middleware/refreshAuthMiddleware";

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  return {
    ...createStore(
      rootReducer,
      process.env.NODE_ENV === "development"
        ? applyMiddleware(
            sagaMiddleware, // injects sagas
            // refreshAuthMiddleware, // refreshes JWT
            //logger // logs all actions
          )
        : applyMiddleware(sagaMiddleware)
    ),
    runSaga: sagaMiddleware.run(rootSaga)
  };
};

export default configureStore;
